<div class="no-content-message" [ngClass]="classes" [ngStyle]="{'padding': padding}">
  <!-- , 'margin': margin -->
  <h2>{{message}}</h2>
</div>